import React from 'react';
import { CloseIcon } from '@util/svgicon';
import TestdriveNoBotIcon from '@images/testdriveNoBot.svg';

const NoTestBot = ({ closeNoTestBotModel }) => {
    return (
        <div className='flex w-[520px] p-[16px] flex-col items-start gap-[16px] rounded-[32px] bg-[#F3F3F3]'>
            <div className='w-full flex px-[16px] py-[6px] justify-between items-center'>
                <p className="text-[#000] text-center text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px] w-[96%]">
                    No test bot available
                </p>
                <button onClick={closeNoTestBotModel}>
                    <CloseIcon />
                </button>
            </div>
            <div className='flex p-[16px] flex-col items-center gap-[32px] rounded-[16px] bg-[#FFF]'>
                <div className='w-[456px] h-[120px]'>
                    <img src={TestdriveNoBotIcon} alt='TestdriveNoBotIcon' className='w-full h-full object-contain' />
                </div>
                <p className='text-[#727272] text-center text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>Sorry, all test bots are currently in use. Please try again in a few minutes or come back later!</p>
            </div>
            <div className='w-full flex p-[16px] flex-col items-start gap-[16px] rounded-[16px] bg-[#FFF]'>
                <button className='w-full flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#000]' onClick={closeNoTestBotModel}>
                    <p className='text-[#F3F3F3] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>Close</p>
                </button>
            </div>
        </div>
    )
}

export default NoTestBot